import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetRewardEventModel } from "@factory/model/query-model-reward-event";
import { rewardEventFormDefault } from "./form.default";
import { RewardEventFormSchema } from "./form.rule";

export const useFormDefaultRewardEvent = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetRewardEventModel | undefined) => {
    return !cachedValue
      ? rewardEventFormDefault
     : ({
        tenant: cachedValue.tenant,
        name: cachedValue.name,
        description: cachedValue.description,
        isPoints: Boolean(cachedValue.is_points),
        isStamp: Boolean(cachedValue.is_stamp),
        isLevel: Boolean(cachedValue.is_level),
        denominationPoints: cachedValue.denomination_points,
        points: cachedValue.points,
        denominationStamp: cachedValue.denomination_stamp,
        stamp: cachedValue.stamp,
        startDate: formatDate(cachedValue.start_date) as any,
        endDate: formatDate(cachedValue.end_date) as any,
      } as RewardEventFormSchema);
  };

  return {
    getDefault,
  };
};
